import { createContext, useContext } from "react";
import { ApplicantType } from "shared/types";
import {
  Template,
  VerificationSchema,
  VerificationStep,
  VerifiedIncome
} from "types/landlord/verificationTemplate";
import { VerificationSchemaView } from "../slices/types";
import { Configurations } from "types/common/configurations";

export const TemplateContext = createContext<{
  canSave: boolean;
  template: Template | null;
  savedTemplate: Template | null;
  verificationSchemas?: VerificationSchema[];
  setTemplate: (template: Template) => void;
  readOnly: boolean;
  isModal: boolean;
  createMode: boolean;
  partnerType: ApplicantType;
  setPartnerType: (partnerType: ApplicantType) => void;
  selectedVerificationSchema: VerificationSchemaView;
  setSelectedVerificationSchema: (
    selectedVerification: VerificationSchemaView
  ) => void;
  selectedStep: number;
  setSelectedStep: (step: number) => void;
  combinedVerificationSchemas: VerificationStep[];
  verifiedIncome: VerifiedIncome;
  setVerifiedIncome: (value: VerifiedIncome) => void;
  configurations?: Configurations;
  setCanSave: (value: boolean) => void;
}>({
  template: null,
  savedTemplate: null,
  verificationSchemas: undefined,
  setTemplate: () => {},
  readOnly: false,
  isModal: false,
  createMode: false,
  partnerType: ApplicantType.Applicant,
  setPartnerType: () => {},
  selectedVerificationSchema: VerificationSchemaView.ScreeningServices,
  setSelectedVerificationSchema: () => {},
  selectedStep: 0,
  setSelectedStep: () => {},
  combinedVerificationSchemas: [],
  verifiedIncome: {},
  setVerifiedIncome: () => {},
  canSave: true,
  setCanSave: () => {}
});

// eslint-disable-next-line react-refresh/only-export-components
export const useTemplateContext = () => {
  return useContext(TemplateContext);
};
